import { ArrowLeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { OptionType } from 'api';
import RunningTotal from 'components/runningtotal/running-total';
import Typography from 'helpers/fonts';
import React, { useEffect, useState } from 'react';
import { useAppState } from 'state/appstate/appstate';
import { useSmallScreen } from 'helpers/isSmallScreen';
import shallow from 'zustand/shallow';
import TabPane from './tabpane';
import { filterAvailableOptions } from './options-sidebar';
import { ActionType, StyleAssetType } from '@swd_admin/cdc-viewer';
import { useViewerState } from 'state/viewer-state/viewer-state';
import { useUiState } from 'state/ui-state/ui-state';

const OptionsSidebarSmall: React.FunctionComponent = () => {
  const isSmallScreen = useSmallScreen();
  const { focusType, setFocusType } = useUiState();
  const { viewer, viewerState } = useViewerState();
  const { options, optionTypes, optionFolders } = useAppState(
    (state) => ({
      options: filterAvailableOptions(state.styleProduct.style?.options),
      optionTypes: state.styleProduct.style?.optionTypes,
      optionFolders: state.styleProduct.style?.optionFolders,
    }),
    shallow
  );

  const [activeType, setActiveType] = useState<OptionType | undefined>(
    undefined
  );
  const [opened, setOpened] = useState<boolean>(false);

  useEffect(() => {
    const focus = activeType?.displayName === 'Roof'
      ? StyleAssetType.Roof
      : StyleAssetType.Wall;
    if (focus !== focusType && viewer) {
      viewer.dispatch({
        type: ActionType.SetFocus,
        focusType: focus,
      });
      setFocusType(focus);
    }
  }, [activeType, viewerState]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: `calc(100% - 22px)`, // Doors / Windows / etc title header
        background: Theme['@grey-lightest'],
      }}
    >
      {(!activeType || !opened) &&
        optionTypes &&
        optionTypes.map((oType) => (
          <Button
            block
            type="link"
            key={oType.displayName}
            onClick={() => {
              setActiveType(oType);
              setOpened(true);
            }}
            style={{
              height: 48,
              display: 'flex',
              justifyContent: 'space-between',
              color: Theme['@black'],
            }}
          >
            <Typography style={{ color: Theme['@black'] }} styleid={6}>
              {oType.displayName}
            </Typography>

            <RightOutlined />
          </Button>
        ))}
      {opened && activeType && (
        <>
          <div
            onClick={() => setOpened(false)}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0 16px',
            }}
          >
            <ArrowLeftOutlined />
            <Typography style={{ color: Theme['@black'] }} styleid={6}>
              {activeType.displayName}
            </Typography>
            <span />
          </div>
          <TabPane
            title={activeType.displayName}
            description={activeType.displayName}
            filters={optionFolders?.filter((folder) =>
              activeType.optionFolderIds?.includes(folder.id)
            )}
            options={options?.filter(
              (option) => activeType.id === option.optionTypeId
            )}
            runningTotalHeight={0}
            // optionSettings={}
          />
        </>
      )}

      {!isSmallScreen && (
        <div style={{ marginTop: 'auto' }}>
          <RunningTotal />
        </div>
      )}
    </div>
  );
};

export default OptionsSidebarSmall;
